import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitScheduledModel } from '@apps-common/types/portal/unit-scheduled'

export const updateUnitScheduled = async (model: IUnitScheduledModel): Promise<IUnitScheduledModel> =>
  axios.post(`/my-monitoring/sites/UpdateSchedule`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitScheduledModel
}

export const useMyMonitoringUpdateUnitScheduled = (
  notify?: boolean,
  onSuccess?: (data: IUnitScheduledModel) => void,
  onError?: () => void
) =>
  useMutation({
    mutationKey: ['updateMyMonitoringUnitSchedule'],
    mutationFn: ({ model }: Props) => updateUnitScheduled(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated schedule.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to updated schedule, please try again.')
      }
      if (onError) {
        onError()
      }
    },
    throwOnError: false
  })
